import { combineReducers } from 'redux';

import { openReducer } from './open';
import { stepReducer } from './step';
import { textReducer } from './text';
import { TReduxActions } from '../../types/redux';
import { ENewQuestionModalStep, INewQuestion } from '../../types/newQuestion';
import { nameReducer } from './name';
import { isAnonymousReducer } from './isAnonymous';

export const defaultNewQuestion = {
  isAnonymous: null,
  name: null,
  open: false,
  step: ENewQuestionModalStep.Question,
  text: '',
};

export const newQuestionReducer = combineReducers<INewQuestion, TReduxActions>({
  name: nameReducer,
  open: openReducer,
  step: stepReducer,
  text: textReducer,
  isAnonymous: isAnonymousReducer,
});
